import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

import { GET_STANDARD_USER } from "actions/ActionTypes";
import { getApi } from "actions/SendActions";

import UsersAdminForm from "components/analytics/userAnalytics/UsersAdminForm";
import { updateUser } from "api/legacy/UserAPI";
import useAbility from "hooks/useAbility";

import "css/admin/smartlist.scss";

function UsersAdminUpdateUI({ match, t }) {
  const dispatch = useDispatch();
  const { projectSlug } = useParams();
  const { token } = useSelector((state) => state.loginReducer);
  const orgaOptions = useSelector(
    (state) => state.fetchReducer.orga_config.data?.organization_options,
  );

  const { canAccess } = useAbility();

  const { project: canAccessProject } = canAccess(orgaOptions);

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!user) {
      getUser(match?.params?.id);
    }
  }, [user]);

  const onUpdate = (item) => {
    if (item.avatar) delete item.avatar_url;

    onSubmit(item.uuid, item, token, t);
  };

  const getUser = (uuid) => {
    dispatch(
      getApi({
        endpoint: `/api/user/v3/admin/users/${uuid}`,
        type: GET_STANDARD_USER,
        item: "users",
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        callback: (user) => {
          setUser(user);
        },
      }),
    );
  };

  const onSubmit = (uuid, data, token, t) => {
    dispatch(updateUser(uuid, data, token, projectSlug, t));
  };

  if (!projectSlug || !user) {
    return null;
  }

  return (
    <UsersAdminForm
      isDisabled={!canAccessProject.usersWrite}
      commentsDisabled={!canAccessProject.community}
      item={user}
      onSubmit={onUpdate}
      type="edit"
    />
  );
}

UsersAdminUpdateUI.propTypes = {
  match: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(
  "editor-users",
  "editor-errors",
)(UsersAdminUpdateUI);
